import { jsxs as r, jsx as c } from "react/jsx-runtime";
const t = (l) => /* @__PURE__ */ r(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ...l,
    children: [
      /* @__PURE__ */ c(
        "path",
        {
          fill: "currentcolor",
          d: "M8.755 3.015c.085-.013.158-.015.27-.015 1.46 0 2.65 1.387 2.92 3.114.289 1.866-.575 3.649-2.108 3.855l-.092.016-.084.01-.187.005c-1.458 0-2.648-1.389-2.92-3.114-.29-1.866.576-3.649 2.108-3.855zM19.78 7h-.03c-1.219.02-2.35 1.066-2.908 2.504-.69 1.775-.348 3.72 1.075 4.333.256.109.527.163.801.163 1.231 0 2.38-1.053 2.943-2.504.686-1.774.34-3.72-1.076-4.332A2.1 2.1 0 0 0 19.78 7M12 10c-1.32 0-1.983.421-2.931 1.924l-.244.398-.395.688-.141.254c-.24.434-.571.753-1.14 1.142l-.55.365c-.94.627-1.431 1.118-1.706 1.955-.124.338-.196.853-.193 1.28C4.7 19.693 5.898 21 7.5 21l.242-.006c.119-.006.234-.017.354-.034l.248-.043.132-.028.29-.073.163-.045.57-.17.763-.243.455-.136c.53-.15.94-.222 1.283-.222.344 0 .753.073 1.283.222l.455.136.764.242.569.171.312.084q.145.036.273.062l.248.043c.12.017.235.028.354.034L16.5 21c1.602 0 2.8-1.307 2.8-3 0-.427-.073-.939-.207-1.306-.236-.724-.677-1.223-1.48-1.83l-.257-.19-.528-.38c-.642-.47-1.003-.826-1.253-1.278l-.27-.485-.252-.432C14.042 10.403 13.435 10 12 10"
        }
      ),
      /* @__PURE__ */ c(
        "path",
        {
          fill: "currentcolor",
          d: "M14.972 3c-1.459 0-2.647 1.388-2.916 3.113-.29 1.867.574 3.65 2.174 3.867q.153.02.296.02c1.39 0 2.543-1.265 2.877-2.883l.041-.23c.29-1.867-.574-3.65-2.174-3.867a2 2 0 0 0-.298-.02M3.42 7.161c.253-.107.523-.161.797-.161 1.231 0 2.378 1.053 2.941 2.504.69 1.773.348 3.72-1.078 4.335a2 2 0 0 1-.797.161c-1.23 0-2.378-1.053-2.94-2.504-.69-1.773-.349-3.72 1.077-4.335"
        }
      ),
      /* @__PURE__ */ c(
        "path",
        {
          stroke: "currentcolor",
          d: "M8.755 3.015c.085-.013.158-.015.27-.015 1.46 0 2.65 1.387 2.92 3.114.289 1.866-.575 3.649-2.108 3.855l-.092.016-.084.01-.187.005c-1.458 0-2.648-1.389-2.92-3.114-.29-1.866.576-3.649 2.108-3.855zM19.78 7h-.03c-1.219.02-2.35 1.066-2.908 2.504-.69 1.775-.348 3.72 1.075 4.333.256.109.527.163.801.163 1.231 0 2.38-1.053 2.943-2.504.686-1.774.34-3.72-1.076-4.332A2.1 2.1 0 0 0 19.78 7ZM12 10c-1.32 0-1.983.421-2.931 1.924l-.244.398-.395.688-.141.254c-.24.434-.571.753-1.14 1.142l-.55.365c-.94.627-1.431 1.118-1.706 1.955-.124.338-.196.853-.193 1.28C4.7 19.693 5.898 21 7.5 21l.242-.006c.119-.006.234-.017.354-.034l.248-.043.132-.028.29-.073.163-.045.57-.17.763-.243.455-.136c.53-.15.94-.222 1.283-.222.344 0 .753.073 1.283.222l.455.136.764.242.569.171.312.084q.145.036.273.062l.248.043c.12.017.235.028.354.034L16.5 21c1.602 0 2.8-1.307 2.8-3 0-.427-.073-.939-.207-1.306-.236-.724-.677-1.223-1.48-1.83l-.257-.19-.528-.38c-.642-.47-1.003-.826-1.253-1.278l-.27-.485-.252-.432C14.042 10.403 13.435 10 12 10Z"
        }
      ),
      /* @__PURE__ */ c(
        "path",
        {
          stroke: "currentcolor",
          d: "M14.972 3c-1.459 0-2.647 1.388-2.916 3.113-.29 1.867.574 3.65 2.174 3.867q.153.02.296.02c1.39 0 2.543-1.265 2.877-2.883l.041-.23c.29-1.867-.574-3.65-2.174-3.867a2 2 0 0 0-.298-.02ZM3.42 7.161c.253-.107.523-.161.797-.161 1.231 0 2.378 1.053 2.941 2.504.69 1.773.348 3.72-1.078 4.335a2 2 0 0 1-.797.161c-1.23 0-2.378-1.053-2.94-2.504-.69-1.773-.349-3.72 1.077-4.335Z"
        }
      )
    ]
  }
);
export {
  t as default
};
